import React from 'react';

import CSRFContext from '@seccon/core/contexts/csrf';
import decodeJson from '@seccon/shared/utils/decodeJson';

async function updateSessionInfo (sessionId, checked) {
  const csrfToken = React.useContext(CSRFContext);

  const response = await fetch(`/personnelComparisonTool/${ sessionId }/verifyRecordsViewOnlyDiffs`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'anti-csrf-token': csrfToken
    },
    body: JSON.stringify({ value: checked })
  });

  if (!response.ok) {
    console.error(`Network response was not ok: ${ response.status }`);
  }
  return decodeJson(response);
}

export default updateSessionInfo;
